import React from "react";
import Link from "gatsby-link";

function Sublinks(props){
  let categories = props.cats;

  return (
    <ul className="subnav">
      {categories.map(function(current){
        return <li key={current.id}>
            <Link to={current.path}>
                {ucwords(current.name)}
            </Link>
          </li>
      })}
    </ul>
  );
}

const Dropdown = ({show, catarr}) => <ul className={`category-dropdown menu-${show ? "visible" : "hidden"}`}>
          <li><Link to="/category/all">View All</Link></li>
            {catarr.map(function(current){
  
              if(current.children.length == 0)
              {
                return (
                <li className="ej-catlink" key={current.category.id}>
                        <Link to={current.category.path}>
                      {ucwords(current.category.name)}
                    </Link>
                      </li>
                )
              }
              else
              {
                return (
                  <li className="ej-catlink" key={current.category.id}>
                        <Link to={current.category.path}>
                       {ucwords(current.category.name)}
                    </Link>
                    <Sublinks cats={current.children} />
                      </li>
                )
              }
            })}
            </ul>

function ucwords(str){
  str = str.toLowerCase();
  return str.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g,
    function(s){
      return s.toUpperCase();
  });
};

export default class Parent extends React.Component {

  state = {
    dropdownVisible: false,
  };

  // toggles the dropdown each time it is called
  toggleDropdown = () => this.setState(state => ({
    dropdownVisible: !state.dropdownVisible,
  }));
    
  render(){
    var catarr = [];
    var cats = this.props.categories.filter(categories => categories.node.name.length > 0).map(({ node: category }) => {
      if(category.root != 'none')
      {
        for(var i in catarr)
        {
          if(catarr[i].id == category.root)
          {
            catarr[i].children.push(category);
          }
        }
      }
      else
      {
        catarr.push({
          id: category.id,
          name: category.name,
          category: category,
          children: []
        });
      }
    });

    return(
      <div id="category-box" onClick={this.toggleDropdown}>
        <div className="current-cat">{this.props.current}</div>
        <Dropdown show={this.state.dropdownVisible} catarr={catarr} />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/CategoryDropdown.js